import React from 'react';
import CustomImage from '../../../components/custom-image';

const DrinkingWater = () => {
  return (
    <div className="accordion-body">
      <div className="sd-content">
          <div className="left">
            <div className="blue-box">
              <p className="feature-title"><strong>Key Features</strong></p>
              <div className="sd-column">
                <div className="left">
                  <p className="bold-text blue-text">24</p>
                  <p className="feature-benifit">initiatives across our Group companies</p>
                </div>
                <div className="right">
                  <p className="feature-subtitle">Nearly</p>
                  <p className="bold-text blue-text">388,000</p>
                  <p className="feature-benifit">people beneﬁt from these programmes</p>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
              <p><strong>Types of Interventions</strong></p>
              <p>
                Provision of drinking water; Construction of toilets; RO plant setup; Digging of borewells; Handpump repair/installation; Sanitation drives
              </p>
            </div>
          </div>
          <div className="right">
            <div className="img-wrapper">
              <CustomImage className="custom-image" imageName="drinking-water.jpg" alt="Drinking Water" maxWidth="768" />
            </div>
          </div>
      </div>
    </div>
  );
};

export default DrinkingWater;
